import { render, staticRenderFns } from "./HeaderBasket.vue?vue&type=template&id=c3cce48a&scoped=true&"
import script from "./HeaderBasket.vue?vue&type=script&lang=js&"
export * from "./HeaderBasket.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBasket.vue?vue&type=style&index=0&id=c3cce48a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cce48a",
  null
  
)

export default component.exports